import React from "react";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Grid from "components/common/Grid";
import IconButton from "components/common/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "components/common/Box";

const DataUploaded = ({ open, handleClose }) => {
  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <Box
          sx={{
            boxSizing: "border-box",
            justifyContent: "center",
            alignItems: "center",
            background: "#FBF9F9",
            border: "1px solid #004AAD",
            borderRadius: "8px",
          }}
        >
          <Grid container justifyContent={"flex-end"}>
            <IconButton color="primary" component="span">
              <CloseIcon
                onClick={() => {
                  handleClose();
                }}
              />
            </IconButton>
          </Grid>
          <Stack
            spacing={2}
            sx={{ justifyContent: "center", alignItems: "center", m: 1 }}
          >
            <img
              style={{ width: "20%", marginTop: "-24px" }}
              src="../images/Group 67505.png"
              alt="logo"
            />
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "600",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              Data uploaded successfully!
            </Typography>
          </Stack>
        </Box>
      </Dialog>
    </>
  );
};

export default DataUploaded;
